import { Block } from '../../types';

export function journeyNodeToBlock(nodeBlock: any): Block {
  return {
    id: nodeBlock.block.id,
    position: nodeBlock.position,
    content: nodeBlock.block.content,
    layout: nodeBlock.block.layout,
  };
}
